import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SERVER_BASE_URL } from '../constants';

import './LoginButtons.css';

const NaverCallback = () => {
    const apiKey = process.env.REACT_APP_X_API_KEY;
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(true); // 초기에는 로딩 중으로 설정

    useEffect(() => {
        const naverLogin = new window.naver.LoginWithNaverId({});

        try {
            naverLogin.getLoginStatus((status) => {
                if (status) {
                    let userId = naverLogin.user.email + "-N";
                    console.log(userId);

                    fetch(`${SERVER_BASE_URL}/sign-in`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'x-api-key': apiKey,
                        },
                        body: JSON.stringify({ 'user_id': userId }),
                    })
                        .then(response => {
                            setLoading(false); // 로딩 종료

                            if (response.ok) {
                                return response.json();
                            } else if (response.status === 404) {
                                alert('회원정보가 존재하지 않습니다.');
                                navigate('/');
                            } else {
                                throw new Error('Network response was not ok.');
                            }
                        })
                        .then(data => {
                            console.log('Success:', data);
                            const authToken = data.authorization_token;
                            localStorage.setItem('authorization_token', authToken);
                            navigate('/main');
                        })
                        .catch(error => {
                            setLoading(false); // 로딩 종료
                            console.error('Error:', error);
                        });
                } else {
                    setLoading(false); // 로딩 종료
                }
            });
        } catch (err) {
            console.log(err);
            setLoading(false); // 로딩 종료
        }
    }, [apiKey, navigate]);

    return (
        <div>
            {isLoading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}
        </div>
    );
};

export default NaverCallback;
